import "./VideoDisplay.css"
import { withRouter } from "react-router-dom";
import {Typography, Grid } from "@mui/material";
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import { CircularProgress } from '@mui/material';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import React, { useEffect, useState } from "react";
import Header from "./Header";
import Dashboard from "./Dashboard";
import {config} from "./App";
import Iframe from 'react-iframe';
import axios from "axios";

const VideoDisplay = (props) => {
const [videos, setVideos] = useState([]);
const [loading, setLoading] = useState(false);
const [likeOn, setLikeOn] = useState(true);
const [unlikeOn, setUnlikeOn] = useState(true);
const [filteredVideos, setFilteredVideos] = useState([]);
const [video, setVideo] = useState([]);

const getVideoById = async () => {
let id = props.match.params.videoId
let url = config.linked/ + id
let response = await axios.get(url);
const videoData = response.data.videos;
setVideo(videoData);
}

const fetchVideos  = async() => {
    let url = `${config.linked}`;
    let response = await axios.get(url);
    const videos = response.data.videos;
    setVideos(videos);
    setFilteredVideos(videos);
}

const patchView = async() =>{
    await fetch(config.linked +props.match.params.videoId+"/views", {
      method:'PATCH',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    })
    .then((res) => res)
    .catch((error) => console.log(error));
  }

useEffect(() => {
    fetchVideos();
    getVideoById();
    patchView();
  }, []);

const like = async(val) => {
    let id = props.match.params.videoId
    const resp = await fetch(config.linked + "/" + id+"/votes", {
      method:'PATCH',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: JSON.stringify({
          "vote": "upVote",
          "change": val 
      })
    })
    .then((res) => res)
    .catch((error) => console.log(error)); 
    // console.log(resp) 
    if(resp.ok){
      
      if(val === "decrease"){
        setLikeOn(false)
        
      }else{
        setLikeOn(true)
      }
       
    
    }
  }



  const unlike = async(val) => {
    let id = props.match.params.videoId
    const resp = await fetch(config.linked + "/" +id+"/votes", {
      method:'PATCH',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: JSON.stringify({
        "vote": "downVote",
        "change": val 
      })
    })
    .then((res) => res)
    .catch((error) => console.log(error));
    if(resp.ok){
      
      if(val === "decrease"){
        setUnlikeOn(false)
      }else{
        setUnlikeOn(true)
        
      }
      
    }
   
  }

 
return (
    
    <div className="mainVideoDisplay">
        <Header history={props.history} />
        { loading? (<div className="loadingScreen">
<CircularProgress/>
     </div>) : <div className="videoDisplayBody">
        <div className="iframeParent">
        <Iframe url={`https://www.${props.location.state.data.videoLink}`} width="100%" height="100%" allow="fullscreen" class="iframe"></Iframe>
        </div>
        <div className="title">
        <h2 fontWeight="700" className="videoTitle">{props.location.state.data.title}</h2>
        </div>
        <div className="iframeInfo">
        <div className="iframeDetails">
        <Typography variant="body2" color="#D1D5DA" fontWeight="400" marginRight={1}>{props.location.state.data.contentRating} </Typography>
        <Typography variant="body2" color="#D1D5DA" fontWeight="400" marginRight={1}> ● </Typography>
        <Typography variant="body2" color="#D1D5DA" fontWeight="400">{props.location.state.data.date}</Typography>
        </div>
        <div className="likeDislike">
            {likeOn ? (<span id="like" 
              className="inactive-btn" onClick={()=> like("decrease")}>{<ThumbUpIcon className="thumbUp"/>}{props.location.state.data.votes.upVotes}</span>) : (<span id="like" 
              className="active-btn" onClick={()=> like("increase")}>{<ThumbUpIcon className="thumbUp"/>}{props.location.state.data.votes.upVotes}</span>) }
                {unlikeOn ? (<span id="dislike" 
              className="inactive-btn"  onClick={()=> unlike("decrease")}>{<ThumbDownAltIcon className="thumbDown"/>}{props.location.state.data.votes.upVotes}</span>) : (<span id="dislike" 
              className="active-unlike" onClick={()=> unlike("increase")}>{<ThumbDownAltIcon className="thumbDown"/>}{props.location.state.data.votes.upVotes}</span>) }
        </div>
        </div>
        <div className="lineDisplay"> </div>
        
        <Grid
        container
        spacing={2}
        
      >
        {" "}
        {filteredVideos.map((video) => {
         
          return (
            <Grid item xs={6} sm={6} md={3}>
              <Dashboard
               data={video}
              />
            </Grid>
          );
        })}
      </Grid>
    </div>}
    
    
    </div>
)

}
export default withRouter(VideoDisplay)